import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';
import { mediaQueries } from '../../../styles/media-queries';
import { Button as StyledButton } from '../styles';

export const Button = styled(StyledButton)`
  min-width: ${pxToRem(146)};
  min-height: ${pxToRem(36)};
  -webkit-tap-highlight-color: transparent;

  transition: all 0.3s cubic-bezier(0, 0.7, 0.3, 1.01);
  will-change: width, flex-grow;

  ${({ theme }) => `
    height: ${pxToRem(56)};
    font-size: ${theme.fontSize.m};
    border-radius: ${pxToRem(8)};
  `}

  ${mediaQueries.desktop} {
    min-width: ${pxToRem(146)};
    min-height: ${pxToRem(36)};
    height: ${pxToRem(56)};
    font-size: ${({ theme }) => theme.fontSize.m};
    border-radius: ${({ theme }) => theme.borderRadius.input_mobile_nav};
  }
`;
